import { State, createFeatureSelector, createSelector } from "@ngrx/store";
import * as SitNGoReducer from './sit-n-go-summaries.reducer';
import * as mainReducers from '@app/store/features/main/main.reducers';

export const selectMainState = createFeatureSelector<mainReducers.MainState>('main');
export const selectSitNGoSummariesState = createSelector(selectMainState, (state) => state.sitNGoSummaries);


export const {
    selectIds,
    selectEntities,
    selectAll,
    selectTotal,
} = SitNGoReducer.adapter.getSelectors(selectSitNGoSummariesState);

export const selectLoader = createSelector(
    selectSitNGoSummariesState,
    (state) => state?.loader
);

export const selectEntityById = (id: number) => createSelector(
    selectEntities,
    (entities) => entities[id]
);
